import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import api from "../lib/api";
import RecordingCard from "../components/RecordingCard";
import { Spinner, EmptyState } from "../components/states";
import { BackButton, Breadcrumbs, ExternalLink, useEscape } from "../lib/nav";

export default function Library() {
  const [recs, setRecs] = useState([]);
  const [genres, setGenres] = useState([]);
  const [genre, setGenre] = useState("");
  const [sort, setSort] = useState("newest");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (genre) params.set("genre", genre);
    if (sort) params.set("sort", sort);
    if (q) params.set("q", q);
    const { data } = await api.get(`/recordings?${params.toString()}`);
    setRecs(data); setLoading(false);
  };

  useEffect(() => { api.get("/genres").then((r) => setGenres(r.data)); }, []);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [genre, sort]);

  return (
    <div className="mx-auto max-w-[1600px] px-4 sm:px-6 py-8">
      <div className="flex items-center gap-4 flex-wrap mb-4"><BackButton fallback="/" /><Breadcrumbs items={[{ label: "Live", to: "/" }, { label: "Archive" }]} /></div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight">Archive</h1>
      <p className="mono-label text-[#71717A] mt-2">ALL SHOWS · RAV3.LABS-STUDIO</p>

      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <div className="flex items-center gap-2 bg-[#121216] border border-[#27272A] rounded-lg px-3 flex-1 max-w-md focus-within:border-[#E8552A]">
          <Search size={16} className="text-[#71717A]" />
          <input data-testid="library-search" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
            placeholder="Search shows…" className="bg-transparent py-2.5 text-sm outline-none flex-1" />
        </div>
        <select data-testid="sort-select" value={sort} onChange={(e) => setSort(e.target.value)} className="bg-[#121216] border border-[#27272A] rounded-lg px-3 py-2.5 text-sm mono-label outline-none focus:border-[#E8552A]">
          <option value="newest">NEWEST</option><option value="oldest">OLDEST</option><option value="popular">MOST POPULAR</option>
        </select>
      </div>

      <div className="flex flex-wrap gap-2 mt-4">
        <button onClick={() => setGenre("")} className={`mono-label rounded-full px-3 py-1.5 border ${!genre ? "border-[#E8552A] text-[#E8552A]" : "border-[#27272A] text-[#A1A1AA]"}`}>ALL</button>
        {genres.map((g) => (
          <button key={g} data-testid={`genre-${g}`} onClick={() => setGenre(g)} className={`mono-label rounded-full px-3 py-1.5 border ${genre === g ? "border-[#E8552A] text-[#E8552A]" : "border-[#27272A] text-[#A1A1AA] hover:border-[#E8552A]/50"}`}>{g}</button>
        ))}
      </div>

      <div className="mt-8">
        {loading ? <Spinner /> : recs.length === 0 ? <EmptyState title="No shows found" sub="Try a different filter or search." /> : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {recs.map((r, i) => <RecordingCard key={r.id} rec={r} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
